"use client"

import React, { useContext } from "react"
// import { useRouter } from "next/router"
import { usePathname } from "next/navigation"
import { Link } from "@/i18n/routing"
import Container from "../Container/Container"
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs"
import RegularButton from "../RegularButton/RegularButton"
import styles from "./Intro.module.scss"
import { ModalContext } from "@/contexts/ModalProvider"

export default function Intro({
  name,
  date,
  desc,
  place,
  pageName = "Horizon Poland 2023",
  signupText = "Sign up to the event",
  home = "Home",
  CallToAction = false,
  img = "/images/poland2023/warsaw-intro-bg.jpg",
  imgMobile = "/images/poland2023/warsaw-intro-bg_mobile.jpg",
  theme = "",
  langs,
}) {
  const { setOpenModal } = useContext(ModalContext)
  const pathname = usePathname()

  return (
    <section
      className={`${styles.intro} ${
        theme == "home" ? styles["intro--home"] : ""
      }`}
      id="intro"
    >
      <Container className={styles.intro__container}>
        <div className={styles.intro__text}>
          {theme != "home" && (
            <Breadcrumbs
              home={home}
              className={styles.intro__breadcrumbs}
              items={[{ name: pageName }]}
            ></Breadcrumbs>
          )}
          <div
            className={styles.intro__date}
            dangerouslySetInnerHTML={{ __html: date }}
          ></div>
          <h1 dangerouslySetInnerHTML={{ __html: name }}></h1>
          {theme != "home" && (
            <p dangerouslySetInnerHTML={{ __html: desc }}></p>
          )}

          <div className={styles.intro__location}>
            <a
              href="https://goo.gl/maps/uyYMucv24L2eQ3ue9"
              target="_blank"
              rel="noreferrer"
              dangerouslySetInnerHTML={{ __html: place }}
            ></a>
          </div>
          {CallToAction ? (
            <CallToAction />
          ) : (
            <RegularButton
              text={signupText}
              onClick={() => setOpenModal(true)}
            ></RegularButton>
          )}
        </div>
        {theme != "home" && (
          <div className={styles.intro__langbuttons}>
            {langs &&
              langs.map((lang) => {
                if (lang.url === pathname) {
                  return (
                    <div
                      key={lang.url}
                      className={`${styles.intro__lang} ${styles.intro__lang_active}`}
                    >
                      {lang.name}
                    </div>
                  )
                }
                return (
                  <Link
                    key={lang.url}
                    href={
                      lang.url
                      // pathname.startsWith("/poland")
                      //   ? `${lang.url}${pathname.split("/")[1]}`
                      //   : `${lang.url}${pathname.split(lang.url).reverse()[0]}/`
                    }
                    className={styles.intro__lang}
                  >
                    {lang.name}
                  </Link>
                )
              })}
          </div>
        )}
      </Container>
      {img && (
        <img
          className={`${styles.intro__img} ${
            imgMobile ? styles.intro__img_withmobile : ""
          }`}
          src={img}
          alt="Horizon Poland 2023 palace"
        />
      )}
      {imgMobile && (
        <img
          className={`${styles.intro__img} ${styles.intro__img_mobile}`}
          src={imgMobile}
          alt="Horizon Poland 2023 palace"
        />
      )}
    </section>
  )
}
